<template>
  <!-- Profile dropdown -->
  <div class="flex shrink-0 border-t border-secondary-200 p-4 py-3">
    <a href="#" class="group block w-full shrink-0">
      <div class="flex items-center">
        <div>
          <span v-if="getUserProfile?.firstName && getUserProfile?.lastName">
            <BaseAvatar
              :firstname="getUserProfile.firstName"
              :lastname="getUserProfile.lastName"
              :colour="getUserProfile?.colourCode"
              :size="10"
            />
          </span>
          <span
            v-else
            class="inline-flex h-10 w-10 items-center justify-center rounded-full bg-secondary-200"
          >
            <UserIcon class="h-6 w-6 text-secondary-500" aria-hidden="true" />
          </span>
        </div>
        <div class="ml-3">
          <p
            class="text-sm font-medium text-secondary-700 group-hover:text-secondary-900"
          >
            {{ getUserProfile?.username || "user" }}
          </p>
          <BaseButton
            @click="viewProfile"
            type="none"
            fromAvatar
            class="inline cursor-pointer bg-default text-xs font-medium text-secondary-500 hover:text-primary-700 -ml-4 -mt-1"
          >
            View Profile
          </BaseButton>
        </div>
        <div class="ml-auto">
          <BaseButton
            type="none"
            class="focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-1"
            aria-label="logout"
            @click="logout"
          >
            <ArrowRightEndOnRectangleIcon
              class="h-5 w-5 text-secondary-700 hover:text-primary-500"
              aria-hidden="true"
            />
          </BaseButton>
        </div>
      </div>
    </a>
  </div>
</template>

<script lang="ts" setup>
import { keycloakAuthService } from "@/services/keycloak-auth.service";
import { useRouter } from "vue-router";
import alertMixins from "@/mixins/alert-mixins";
import broadcast, { BroadcastChannelName } from "@/helpers/broadcast";
import { ROUTE_NAME } from "@/router/routes.constants";
import { storeToRefs } from "pinia";
import { useUserAccountsStore } from "@/pinia/useUserAccountsStore";

const router = useRouter();
const { postBroadcastMessage } = broadcast();
const { getUserProfile } = storeToRefs(useUserAccountsStore());
const { errorHandlerAlert } = alertMixins();

const logout = () => {
  localStorage.setItem("tabReload", "true");
  postBroadcastMessage(BroadcastChannelName.TAB_RELOAD, "tabReload");
  keycloakAuthService.logout();
};

const viewProfile = () => {
  window.localStorage.setItem("settingTab", "user-profile");
  router
    .push({
      name: ROUTE_NAME.SETTINGS,
    })
    .catch(errorHandlerAlert);
};
</script>
